import { Component, h, createRef } from 'preact';
import { initFrameAndPoll, sendFrameHeight } from '@newswire/frames';

class FramesChild extends Component {
  constructor(props) {
    super(props);
    this.ref = createRef();

    const { polling } = this.props;

    let opts = {};
    if (polling) opts.polling = polling;
  }

  componentDidMount() {
    const { polling } = this.props;

    initFrameAndPoll(polling);
  }

  componentDidUpdate() {
    sendFrameHeight();
  }

  render({ class: klass }) {
    return (
      <div class={klass} ref={this.ref}>
        {this.props.children}
      </div>
    );
  }
}

export default FramesChild;